import acquisitionTypes, {
  acquisitionTypeTitles,
} from '../../support/acquisitionTypes';
import type { AcquisitionTypeRule } from './types';
import type { SubscriptionOffer } from '../../../shared/models/subscriptionOffer';

const ALACARTE_LICENSE_TAB = {
  type: acquisitionTypes.ALACARTE_LICENSE,
  title: acquisitionTypeTitles.ALACARTE_LICENSE,
};

const isSubscriberAlacarteCase = (
  hasRfSubscription: boolean,
  isCoveredByRf: boolean
): boolean => hasRfSubscription && !isCoveredByRf;

// An eligible non-subscriber is offered the a-la-carte card when there is no
// subscription we can actually sell them for this asset — that is, no sub-family
// is both included in the asset and purchasable in-country. (When one is, both
// included and purchasable, subscriptionLicenseRule runs first and wins with
// SUBSCRIPTION_LICENSE, so this branch is never reached.)
const isNonSubscriberAlacarteCase = (
  hasRfSubscription: boolean,
  isSubscriptionEligible: boolean,
  subscriptionOffer: SubscriptionOffer
): boolean =>
  !hasRfSubscription &&
  isSubscriptionEligible &&
  subscriptionOffer.kind === 'alacarte';

const isValidAsset = (
  assetIsPurchaseable: boolean,
  isImage: boolean,
  isRfAsset: boolean
): boolean => assetIsPurchaseable && (isImage || isRfAsset);

const isAlacarteCase = (
  hasRfSubscription: boolean,
  isCoveredByRf: boolean,
  isSubscriptionEligible: boolean,
  subscriptionOffer: SubscriptionOffer
): boolean =>
  isSubscriberAlacarteCase(hasRfSubscription, isCoveredByRf) ||
  isNonSubscriberAlacarteCase(
    hasRfSubscription,
    isSubscriptionEligible,
    subscriptionOffer
  );

const alacarteRule: AcquisitionTypeRule = ({
  isSubscriptionExperienceActive,
  hasRfSubscription,
  isSubscriptionEligible,
  subscriptionOffer,
  assetIsPurchaseable,
  isCoveredByRf,
  isImage,
  isRfAsset,
}) => {
  if (!isSubscriptionExperienceActive) return null;
  if (!isValidAsset(assetIsPurchaseable, isImage, isRfAsset)) return null;
  if (!isSubscriptionEligible) return null;
  if (
    isAlacarteCase(
      hasRfSubscription,
      isCoveredByRf,
      isSubscriptionEligible,
      subscriptionOffer
    )
  ) {
    return ALACARTE_LICENSE_TAB;
  }
  return null;
};

export default alacarteRule;
